const config = {
  apiGateways: {
    BASE_URL_1: `${window.location.origin}/crash/backend/api/v1`
    // BASE_URL_1: process.env.REACT_APP_BACKEND_URL_HTTP
    // BASE_URL_1: 'http://45.198.13.249:8004/api/v1'
  },
  SOCKET_URL: `${(window.location.origin).replace('https', 'wss')}`,
  // SOCKET_URL: process.env.REACT_APP_BACKEND_URL_WS,
  // SOCKET_URL: 'ws://45.198.13.249:8004',
  API_ENCRYPTION_KEY: process.env.REACT_APP_API_ENCRYPTION_KEY
}

export default config
